import { observer } from 'mobx-react-lite';
import React from 'react';
import { TabPanel } from 'react-tabs';
import { useWebsocketStore } from '../../../../../../../../../stores/websocketStore/websocketProvider';
import style from '../../IndividualTacticStyle.module.css';
import { ScalingInTacticPanelHeader } from './ScalingInTacticPanelHeader';
import { ScalingInTacticPanelRows } from './ScalingInTacticPanelRows';

export const ScalingInTacticPanel = observer(
  // eslint-disable-next-line no-unused-vars
  ({ tradePlanId, addTab, ...rest }) => {
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId];
    const qtyBasis = tradePlan.quantityBasis;
    const breakPricesArr = tradePlan.positionTactics['SCALING_IN'].breakPrices;
    const qtyBasisArr = tradePlan.positionTactics['SCALING_IN'].quantityBasisValues;
    
    if (!tradePlan?.positionTactics['SCALING_IN']) return null;
    return (
      <TabPanel {...rest}>
        <div className={style.tableContainer}>
          <table className={style.table}>
            <ScalingInTacticPanelHeader />
            <ScalingInTacticPanelRows qtyBasis={qtyBasis}  qtyBasisArr={qtyBasisArr} breakPricesArr={breakPricesArr} tradePlanId={tradePlanId}/>
          </table>
        </div>
      </TabPanel>
    );
  }

);

ScalingInTacticPanel.tabsRole = 'TabPanel';

